module.exports = __webpack_public_path__ + "img/bql.0e138594.png";